module.exports = __webpack_public_path__ + "static/media/bird_pick_sticks.af439829.png";